/*
 *
 * EmailNotifications actions
 *
 */

import {
  DEFAULT_ACTION,
  GET_ALL_EMAILS,
  HANDLE_ALL_EMAILS_RESPONSE,
  UPDATE_ALL_EMAILS_DATA,
  ENABLE_LOADER,
  DISABLE_LOADER,
  REMOVE_EMAIL,
  HANDLE_REMOVE_EMAIL,
  UPDATE_EMAIL_CHANNEL_STATUS,
  HANDLE_UPDATE_EMAIL_CHANNEL_STATUS_RESPONSE,
  ADD_BULK_EMAIL,
  HANDLE_ADD_BULK_EMAIL_RESPONSE,
  UPDATE_CUSTOMER_NOTIFICATIONS_STATUS,
  HANDLE_UPDATE_CUSTOMER_NOTIFICATIONS_STATUS,
  RESET_DATA,
  SET_ERROR_IN_ADDING_RECIPIENT,
  SET_ACTIVE_NAVIGATION,
  GET_CUSTOMER_REFUND_NOTIFICATIONS,
  UPDATE_CUSTOMER_REFUND_NOTIFICATIONS_STATUS,
  HANDLE_UPDATE_CUSTOMER_REFUND_NOTIFICATIONS_STATUS,
} from './constants';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function setActiveTabNavigation(data) {
  return {
    type: SET_ACTIVE_NAVIGATION,
    data,
  };
}

export function getAllEmailsAction(data) {
  return {
    type: GET_ALL_EMAILS,
    data,
  };
}

export function handleAllEmailsResponse(data) {
  return {
    type: HANDLE_ALL_EMAILS_RESPONSE,
    data,
  };
}

export function updateAllEmailsDataAction(data) {
  return {
    type: UPDATE_ALL_EMAILS_DATA,
    data,
  };
}

export function enableLoaderAction() {
  return {
    type: ENABLE_LOADER,
  };
}

export function disableLoaderAction() {
  return {
    type: DISABLE_LOADER,
  };
}

export function removeEmailAction(data) {
  return {
    type: REMOVE_EMAIL,
    data,
  };
}

export function handleRemoveEmailAction(data) {
  return {
    type: HANDLE_REMOVE_EMAIL,
    data,
  };
}

export function updateEmailChannelStatusAction(data) {
  return {
    type: UPDATE_EMAIL_CHANNEL_STATUS,
    data,
  };
}

export function handleUpdateEmailChannelStatus(data) {
  return {
    type: HANDLE_UPDATE_EMAIL_CHANNEL_STATUS_RESPONSE,
    data,
  };
}

export function addBulkEmailAction(data) {
  return {
    type: ADD_BULK_EMAIL,
    data,
  };
}

export function handleBulkEmailResponse(data) {
  return {
    type: HANDLE_ADD_BULK_EMAIL_RESPONSE,
    data,
  };
}

export function updateCustomerNotificationsStatusAction(data) {
  return {
    type: UPDATE_CUSTOMER_NOTIFICATIONS_STATUS,
    data,
  };
}

export function handleUpdateCustomerNotificationStatus(data) {
  return {
    type: HANDLE_UPDATE_CUSTOMER_NOTIFICATIONS_STATUS,
    data,
  };
}

export function resetDataAction() {
  return {
    type: RESET_DATA,
  };
}

export const setErrorInAddingRecipient = data => ({
  type: SET_ERROR_IN_ADDING_RECIPIENT,
  data,
});

export function getCustomerRefundNotificationsAction() {
  return {
    type: GET_CUSTOMER_REFUND_NOTIFICATIONS,
  };
}

export function updateCustomerRefundNotificationsStatusAction(data) {
  return {
    type: UPDATE_CUSTOMER_REFUND_NOTIFICATIONS_STATUS,
    data,
  };
}

export function handleUpdateCustomerRefundNotificationsStatus(data) {
  return {
    type: HANDLE_UPDATE_CUSTOMER_REFUND_NOTIFICATIONS_STATUS,
    data,
  };
}
